import $ from "jquery";
import AOS from "aos";

const aosInit = () => {
    $(function () {
        AOS.init({
            duration: 700,
            ease: "ease-out-cubic",
        });
    });

    window.addEventListener("load", function () {
        AOS.refresh();
    });
};

export default aosInit;
